import React, { useState } from "react";
import { Col, Container, Row, FormGroup, Input, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Btn, H2, P, Image } from "../AbstractElements";
import { dynamicImage } from "../Utils";
import axios from "axios";
import { baseUrl } from "../Utils/FileUpload";
import { useForm, Controller, FieldError } from "react-hook-form";

type FormData = {
  email: string;
  password: string;
};

export default function DeleteAccountAgent() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const togglePasswordVisibility = () => setPasswordVisible(!isPasswordVisible);

  const onDeleteAccount = async (data: FormData) => {
    if (!window.confirm("Are you sure you want to delete your account? This action cannot be undone.")) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}agent/delete-account`, {
        email: data.email,
        password: data.password,
      });
      toast.success(response.data.message);
      reset();
      // Redirect to login after successful deletion
      // setTimeout(() => {
      //   navigate("/login");
      // }, 2000);
    } catch (error: any) {
      console.error("Deletion error:", error);
      const errorMessage = error.response?.data?.message || "Failed to delete account";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="p-0" fluid>
      <Row className="m-0">
        <Col xs={12} className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo" to="#">
                  <Image
                    className="img-fluid for-light m-auto"
                    src={dynamicImage(`logo/Logo.png`)}
                    alt="loginpage"
                  />
                  <Image
                    className="img-fluid for-dark"
                    src={dynamicImage(`logo/Logo.png`)}
                    alt="loginpage"
                  />
                </Link>
              </div>
              <div className="login-main">
                <form
                  className="theme-form"
                  onSubmit={handleSubmit(onDeleteAccount)}
                >
                  <H2 className="text-center">Delete Agent Account</H2>
                  <P className="text-center">
                    Enter your email and password to confirm account deletion.
                  </P>

                  <FormGroup>
                    <Col>
                      <Label>Email Address</Label>
                    </Col>
                    <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      rules={{
                        required: "Please enter your email",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      }}
                      render={({ field }) => (
                        <Input
                          type="email"
                          {...field}
                          placeholder="Email"
                          invalid={!!errors.email}
                        />
                      )}
                    />
                    {errors.email && (
                      <div className="text-danger">
                        {(errors.email as FieldError).message}
                      </div>
                    )}
                  </FormGroup>

                  <FormGroup>
                    <Col>
                      <Label>Password</Label>
                    </Col>
                    <Controller
                      name="password"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Please enter your password" }}
                      render={({ field }) => (
                        <div className="form-input position-relative">
                          <Input
                            type={isPasswordVisible ? "text" : "password"}
                            {...field}
                            placeholder="Password"
                            invalid={!!errors.password}
                          />
                          <div
                            className="show-hide"
                            onClick={togglePasswordVisibility}
                          >
                            <span
                              className={!isPasswordVisible ? "show" : ""}
                            ></span>
                          </div>
                        </div>
                      )}
                    />
                    {errors.password && (
                      <div className="text-danger">
                        {(errors.password as FieldError).message}
                      </div>
                    )}
                  </FormGroup>

                  <FormGroup className="mb-0">
                    <div className="text-end mt-3">
                      <Btn
                        color="danger"
                        className="w-100"
                        block
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Delete Account"}
                      </Btn>
                    </div>
                  </FormGroup>

                  <div className="text-center mt-3">
                    <Link className="link" to="/login">
                      Back to Login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* <ToastContainer /> */}
    </Container>
  );
}
